import holidaySummaryComponent from './holidaySummary.component';

let holidaySummaryModule = angular.module('vacations-absences.holidaySummary', [])

.component('holidaySummary', holidaySummaryComponent)

.name;

export default holidaySummaryModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/holidaySummary/holidaySummary.js